core.constant('paymentMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "UI": {
        "TABBAR": {
        },
        "BREADCRUMB": {
        }
      },
      "ENUM" : {
        "OFFER_TYPE" : {
          "SPECIALIZATION" : "Konsultacja",
          "EXAMINATION" : "Badanie",
          "INTERVENTION" : "Zabieg",
          "ONLINE_CONSULTATION" : "Konsultacja online",
          "TRIP" : "Wizyta wyjazdowa",
          "NIGHT_TRIP" : "Wizyta wyjazdowa nocna",
          "ADDITIONAL_PROCEDURE" : "Procedura dodatkowa",
          "REHABILITATION" : "Rehabilitacja",
          "HOME_MEDICAL_CARE" : "Opieka domowa / usługi pielęgniarskie"
        }
      },
      "MODULE": {
        "PAYMENT": {
          "PAYMENTS": "Płatności",
          "INVOICE": "Faktura",
          "TITLE": "Tytuł",
          "AMOUNT": "Kwota",
          "DATE_OF_ISSUE": "Data wystawienia",
          "TERM_OF_PAYMENT": "Termin platności",
          "PAYMENT_AMOUNT": "Kwota zapłaty",
          "DATE_OF_PAYMENT": "Data zapłaty",
          "BALANCE": "Saldo",
          "DOWNLOAD_PDF": "Pobierz PDF",
          "PAY_ONLINE": "Płać on-line",
          "NEW_INVOICE": "Nowa faktura",
          "INVOICE_NUMBER": "Fakruta nr",
          "OPERATIVE_PACKAGE": "Obowiązujacy pakiet",
          "BOUGHT_LICENCES_COUNT": "Liczba zakupionych licencji",
          "REGISTER": "Zarejestruj się",
          "SELECT_PACKAGE": "Wybierz pakiet",
          "ORDER_AND_PAY": "Zamawiam i płacę",
          "TRIAL_VERSION": "Wersja testowa (7-dniowa)",
          "ADDRESS_SAME_AS_COMPANY": "identyczny jak przedsiębiorstwa",
          "MONTH": "Miesiąc",
          "YEAR": "Rok",
          "LICENSE": "Licencja",
          "YEAR_TWELVE_MONTHS": "rok (12 m-cy)",
          "LICENSES_COUNT": "Liczba licencji",
          "GO_TO_SUMMARY": "Przejdź do podsumowania",
          "YOU_HAVE_SELECTED_PACKAGES": "Wybrałaś(łeś) pakiet typu",
          "IN_COUNT": "W ilości",
          "WITH_OPTION": "Z opcją na",
          "FULL_AMOUNT_TO_PAY": "Lączna kwota do zapłaty",
          "GO_TO_PAY_U": "Przejdź do PayU",
          "FROM": "Od",
          "DATE_TO": "Do",
          "PRICE": "Cena",
          "TRIAL_WEEK": "Tydzień",
          "NO_LICENSES_SELECTED": "Nie wybrano żadnej licencji, proszę wybrać co najmniej jedną licencję",
          "TRIAL_PAYMENT_EXPIRATION_WITHIN_DATE": "Uprzejmie przypominamy, iż w panelu płatności znajduje się nowa faktura, której termin płatności upływa w dniu",
          "DAYS": "dni",
          "PAYMENT_EXPIRATION_REMINDER": "Prosimy o uregulowanie zapłaty w terminie",
          "WAITING_FOR_CONFIRMATION": "Oczekiwanie na zatwierdzenie",
          "CANCELED": "Transakcja anulowana"
        }
      }
    }
  }
});
